import React, {useState} from 'react'
import {useDispatch, useSelector} from 'react-redux'
import {Modal} from 'react-bootstrap'
import {
  GetInstallmentsRequest,
  InstallmentDtoListApiData,
  InstallmentDto,
} from '../../api/data-contracts'
import {Api_Payment_GetInstallments} from '../../apiClient/apiClient'
import {postRequestAsync} from '../../redux/commonSlice'
import {getProductState} from '../../redux/productSlice'

function Installment(props: {
  setFieldValue: (field: string, value: any, shouldValidate?: boolean) => void
  setSelectedInstallment: (installment: InstallmentDto) => void
  binNumber: string
}) {
  const dispatch = useDispatch()
  const productState = useSelector(getProductState)
  const [modalShow, setModalShow] = useState(false)
  const [installments, setInstallments] = useState<InstallmentDto[] | null>(null)
  const [selectedInstallment, setSelectedInstallment] = useState<InstallmentDto | null>(null)

  function getInstallments() {
    const body: GetInstallmentsRequest = {
      paymentId: productState?.certainPaymentId,
      binNumber: props.binNumber,
    }
    dispatch<any>(
      postRequestAsync({
        postRequestFunction: Api_Payment_GetInstallments,
        body: body,
      })
    )
      .unwrap()
      .then(async (response: InstallmentDtoListApiData) => {
        if (response?.data) {
          setInstallments(response.data)
          setSelectedInstallment(null) // Reset selection when fetching new data
          setModalShow(true)
        }
      })
      .catch((error: any) => {
        console.error('Error fetching installments:', error)
      })
  }

  function handleClose() {
    setModalShow(false)
  }

  function handleRowSelect(installment: InstallmentDto) {
    setSelectedInstallment(installment)
    props.setFieldValue('installment', installment.installment)
    props.setSelectedInstallment(installment)
  }

  function isRowSelected(installment: InstallmentDto): boolean {
    return selectedInstallment?.installment === installment.installment
  }

  function formatCurrency(amount: number | undefined): string {
    if (amount === undefined || amount === null) return '-'
    return new Intl.NumberFormat('tr-TR', {
      style: 'currency',
      currency: 'TRY',
    }).format(amount)
  }

  return (
    <>
      <div className='px-5 d-flex flex-column' style={{minHeight: '100%'}}>
        <div className='d-flex flex-column mb-3 fv-row mt-auto'>
          <div className='row mb-3'>
            <div className='col-12 d-flex justify-content-end'>
              <button
                type='button'
                className='btn btn-lg btn-primary me-3'
                onClick={getInstallments}
              >
                <span className='indicator-label'>Taksit Seçenekleri</span>
              </button>
            </div>
          </div>
        </div>
      </div>

      <Modal show={modalShow} onHide={handleClose} centered size='lg'>
        <Modal.Header closeButton>
          <Modal.Title>Taksit Seçenekleri</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {installments && installments.length > 0 ? (
            <div className='table-responsive'>
              <table className='table table-bordered' style={{borderCollapse: 'collapse'}}>
                <thead>
                  <tr>
                    <th style={{width: '50px', paddingRight: '15px'}}></th>
                    <th className='text-center' style={{paddingRight: '15px'}}>
                      Taksit Sayısı
                    </th>
                    <th className='text-end' style={{paddingRight: '15px'}}>
                      Taksit Tutarı
                    </th>
                    <th className='text-end' style={{paddingRight: '15px'}}>
                      Toplam Tutar
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {installments.map((installment, index) => (
                    <tr
                      key={index}
                      onClick={() => handleRowSelect(installment)}
                      style={{cursor: 'pointer'}}
                      className={isRowSelected(installment) ? 'table-active' : ''}
                    >
                      <td
                        className='text-center'
                        style={{paddingRight: '15px'}}
                        onClick={(e) => e.stopPropagation()}
                      >
                        <input
                          type='radio'
                          name='installment'
                          checked={isRowSelected(installment)}
                          onChange={() => handleRowSelect(installment)}
                        />
                      </td>
                      <td className='text-center' style={{paddingRight: '15px'}}>
                        {installment.installment ?? '-'}
                      </td>
                      <td className='text-end' style={{paddingRight: '15px'}}>
                        {formatCurrency(installment.price)}
                      </td>
                      <td className='text-end' style={{paddingRight: '15px'}}>
                        {formatCurrency(installment.totalPrice)}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          ) : (
            <div className='text-center py-5'>
              <p>Taksit seçeneği bulunamadı.</p>
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <button type='button' className='btn btn-secondary' onClick={handleClose}>
            Kapat
          </button>
        </Modal.Footer>
      </Modal>
    </>
  )
}

export default Installment
